<template>
<div class="malden-student-form flex flex-col items-center">
  <p class="text-white text-center text-xl">Enter the ID you received in your email to see your customized page!</p>
    <div class="w-full max-w-sm mt-10">
      <form @submit.prevent="submit" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <div class="mb-2">
          <label class="block text-blue text-sm font-bold mb-2" for="password">
            ID*
          </label>
          <input v-validate="'required'" name="Id" v-model="id" class="mb-2 shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline" id="Id" type="text" placeholder="Enter ID">
          <span class="text-sm text-yellow">{{ errors.first('Id') }}</span>
        </div>
          <button class="btn mt-5" type="submit">
            Enter
          </button>
      </form>
  </div>
</div>
</template>

<script>
export default {
  name: "maldenStudentForm",
  data() {
    return {
      id: ""
    };
  },
  methods: {
    submit() {
      this.$validator.validate().then(result => {
        if (result) {
          this.$router.push(`/student/${this.id}`);
        }
      });
    }
  }
};
</script>
